import { COOKIE_NAMES } from "@/lib/constants/config";
import { get_cookie } from "@/lib/browser/cookie-utils";

const prop_firm_match_api_url = "/api/propfirm-match";

export const link_prop_firm_click_to_order = async (
  order_id: number,
): Promise<boolean> => {
  try {
    const prop_firm_match_cookie = get_cookie(
      COOKIE_NAMES.PROP_FIRM_MATCH_CLICK_ID,
    );
    if (prop_firm_match_cookie) {
      const wp_response = await fetch(prop_firm_match_api_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          order_id,
          click_id: prop_firm_match_cookie,
        }),
      });

      if (!wp_response.ok) {
        const error_text = await wp_response.text();
        console.error("Propfirm API error", {
          endpoint: prop_firm_match_api_url,
          method: "POST",
          status: wp_response.status,
          response: error_text,
          timestamp: new Date().toISOString(),
        });
        return false;
      }
      return true;
    }
    return false;
  } catch (error) {
    console.error("Propfirm Service - HTTP request failed", {
      endpoint: prop_firm_match_api_url,
      method: "POST",
      error: error instanceof Error ? error.message : String(error),
      stack: error instanceof Error ? error.stack : undefined,
      timestamp: new Date().toISOString(),
    });
    return false;
  }
};
